export default __webpack_public_path__ + "locales/uk-UA/FillPDFDialog.json?hash=d0f5a53d0d3b5ed79eab17c894dc248c";